import { Route, Routes } from "react-router-dom";
import Dashboard from "../../pages/admin/Dashboard";
import Login from "../../pages/admin/auth/Login";
import MainCategory from "../../pages/admin/category/MainCategory";
import Category from "../../pages/admin/category/Category";
import ServerInfo from "../../pages/admin/ServerInfo";
import Setting from "../../pages/admin/Setting";
import Coupon from "../../pages/admin/Coupon";
import Vendor from "../../pages/admin/Vendor/Vendor";
import Country from "../../pages/admin/address/Country";
import State from "../../pages/admin/address/State";
import City from "../../pages/admin/address/City";
import Admin from "../../pages/admin/admin/Admin";
import StaffAdmin from "../../pages/admin/admin/StaffAdmin";
import SubCategory from "../../pages/admin/category/SubCategory";
import ImportCatgeory from "../../pages/admin/import/ImportCatgeory";
import ImportVendorCategory from "../../pages/admin/Vendor/import/ImportCatgeory";
import VendorStaff from "../../pages/admin/Vendor/VendorStaff";
import ForgotPassword from "../../pages/admin/auth/ForgotPassword";
import MenuPricing from "../../pages/admin/import/MenuPricing";
import ExcelImportProducts from "../../pages/admin/import/ExcelImportProducts";
import PaymentGateway from "../../pages/admin/Vendor/PaymentGateway";
import CorporateCode from "../../pages/admin/CorporateCode";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/head-admin" element={<Admin />} />
      <Route path="/corporate-code" element={<CorporateCode />} />
      <Route path="/tower-admin" element={<StaffAdmin />} />
      <Route path="/vendor" element={<Vendor />} />
      <Route path="/vendor-manager" element={<VendorStaff />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/menu-pricing" element={<MenuPricing />} />
      <Route path="/excel-products/:id" element={<ExcelImportProducts />} />

      {/* address */}
      <Route path="/country" element={<Country />} />
      <Route path="/state" element={<State />} />
      <Route path="/city" element={<City />} />
      
      <Route path="/payment-gateway" element={<PaymentGateway />} />


      
      <Route path="/import-category" element={<ImportCatgeory />} />
      <Route path="/import-vendor-category" element={<ImportVendorCategory />} />

       <Route path="/main-category" element={<MainCategory />} />
       <Route path="/sub-category" element={<SubCategory />} />
       <Route path="/category" element={<Category />} />

      <Route path="/setting" element={<Setting />} />
      <Route path="/server-info" element={<ServerInfo />} />
      <Route path="/coupon" element={<Coupon />} />
      
    </Routes>
  );
};
export default AdminRoutes;
